import { MetaData } from '@/types/meta'

type PropsType = {
  metaData: MetaData
  locale: string
}

const AppFooter = ({ metaData, locale }: PropsType) => {
  return (
    <footer className="border-sidebar-border bg-background/20 supports-backdrop-filter:bg-background/10 sticky bottom-0 z-1 flex min-h-[61] w-full shrink-0 flex-col items-center gap-2 border-t p-5 shadow-sm backdrop-blur-xl sm:flex-row md:px-6">
      <p className="text-muted-foreground text-xs">© 2026 {metaData.contentSettings.title[locale]}.</p>
      <nav className="flex gap-4 sm:ml-auto sm:gap-6">
        <p className="text-muted-foreground text-xs">v1.0.0</p>
      </nav>
    </footer>
  )
}

export default AppFooter
